export const GET_VAULT_LIST = 'GET_VAULT_LIST';


// SPECIALITY HOOKS

export const SPECIALITY_VAULT_LIST = 'SPECIALITY_VAULT_LIST';
